import classNames from 'classnames';
import { get } from 'lodash';
import React, { FC, Fragment } from 'react';
import { useRecoilValue } from 'recoil';
import { CartAtom } from '~/services/cart';
import { Payment, PaymentMethods } from '~/services/payment';
import ConnectAirwallex from '../ConnectAirwallex';
import ConnectStripe from '../ConnectStripe';
import Radio from '../Radio';
import RadioGroup from '../Radio/RadioGroup';
import Text from '../Text';
import styles from './PaymentMethod.module.scss';
import { renderLogoPayment } from '~/utils/html';

interface PaymentMethodProps {
    payment?: Payment;
    errors?: any;
    touched?: Payment;
    onChange?: (key: string, value: string) => void;
    statusPlace?: any;
    formik?: any;
    onChangeElement?: any;
    disbaled?: boolean;
}

const PaymentMethod: FC<PaymentMethodProps> = ({
    payment,
    errors,
    touched,
    onChange,
    statusPlace,
    onChangeElement,
    formik,
    disbaled
}) => {
    const { payment_method } = useRecoilValue(CartAtom.cart);
    const indexStripe: number = payment_method?.findIndex((method) => method.code === PaymentMethods.STRIPE) || -1;
    const _payment_method = [...(payment_method || [])];
    if (indexStripe !== -1) {
        const stripeMethodObj = _payment_method?.splice(indexStripe, 1);
        if (!!stripeMethodObj?.length) {
            _payment_method?.splice(0, 0, stripeMethodObj[0]);
        }
    }
    const handleChange = (key: string, value: string) => {
        if (disbaled) return;
        onChange?.(key, value);
    };
    return (
        <div>
            <RadioGroup className={styles.payment_method}>
                {_payment_method?.map((method, index) => {
                    if (['paypal_express_bml']?.includes(method.code)) return null;
                    return (
                        <div
                            key={index}
                            className={classNames(styles.method_item, {
                                [styles.active]: payment?.code === method.code
                            })}
                            onClick={() => handleChange('code', method.code)}
                        >
                            <div className="flex items-center   gap-2">
                                <div className="flex-1 flex flex-nowrap lg:min-w-52 items-center">
                                    <Radio
                                        checked={payment?.code === method.code}
                                        id={'selected_payment_method.' + method.code}
                                        className="hover:cursor-pointer h-auto"
                                        disabled={disbaled}
                                    />
                                    <Text type="label-3" htmlTag="label" htmlFor="paypal">
                                        {
                                            renderLogoPayment(method, {
                                                width: 48,
                                                height: 48
                                            }).title
                                        }
                                    </Text>
                                </div>
                                <div className="items-end self-end">
                                    {
                                        renderLogoPayment(method, {
                                            width: 32,
                                            height: 32
                                        }).logo
                                    }
                                </div>
                            </div>

                            {payment?.code === PaymentMethods.STRIPE && method.code == PaymentMethods.STRIPE && (
                                <>
                                    <ConnectStripe
                                        onChangeElementStripe={(stripe: any) => onChangeElement(method.code, stripe)}
                                    />
                                </>
                            )}
                            {payment?.code === PaymentMethods.AIRWALLEX && method.code == PaymentMethods.AIRWALLEX && (
                                <>
                                    <ConnectAirwallex />
                                    {!!errors?.target_stripe?.error && (
                                        <span className={styles.error}>{errors?.target_stripe?.error?.message}</span>
                                    )}
                                </>
                            )}

                            {/* <Text type="body-4" className="text-grey-300 ">
              You will be redirected to Paypal payment page to complete the
              payment after clicking “Checkout”
            </Text> */}

                            {get(errors, `${method.code}`) && (
                                <span className={styles.error}>{get(errors, method.code)}</span>
                            )}
                        </div>
                    );
                })}
            </RadioGroup>
        </div>
    );
};

const areEqual = (prevProps: PaymentMethodProps, nextProps: PaymentMethodProps) => {
    return (
        prevProps.payment?.code === nextProps.payment?.code &&
        prevProps.errors === nextProps.errors &&
        prevProps.onChangeElement === nextProps.onChangeElement &&
        prevProps.disbaled === nextProps.disbaled
    );
};

export default React.memo(PaymentMethod, areEqual);
